import Notification from '../components/common/notification/Notification';
import {store} from 'react-notifications-component';
import {NOTIFICATIONS_TYPES} from './constants';

const NOTIFICATION_CLOSE_TIME = 5000;
const DEFAULT_NOTIFICATION_CONFIG = {
  insert: 'top',
  container: 'top-right',
  animationIn: ['animate__animated', 'animate__fadeIn'],
  animationOut: ['animate__animated', 'animate__fadeOut'],
  slidingEnter: {
    duration: 300,
  },
  slidingExit: {
    duration: 300,
  },
};

const createNotification = (
  type,
  {message, title, name, duration = NOTIFICATION_CLOSE_TIME, showImage = true}
) => {
  const id = Date.now();
  store.addNotification({
    ...DEFAULT_NOTIFICATION_CONFIG,
    id,
    content: (
      <Notification type={type} message={message} name={name} title={title} showImage={showImage} />
    ),
  });
  if (!duration) {
    return;
  }
  setTimeout(() => {
    store.removeNotification(id);
  }, duration);
};

export const warning = (config) => createNotification(NOTIFICATIONS_TYPES.warning, config);
export const error = (config) => createNotification(NOTIFICATIONS_TYPES.error, config);
export const success = (config) => createNotification(NOTIFICATIONS_TYPES.success, config);
export const info = (config) => createNotification(NOTIFICATIONS_TYPES.info, config);
